import { render, staticRenderFns } from "./DashboardClientPostLogoutRedirectUri.vue?vue&type=template&id=39d1db87&"
import script from "./DashboardClientPostLogoutRedirectUri.vue?vue&type=script&lang=ts&"
export * from "./DashboardClientPostLogoutRedirectUri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39d1db87')) {
      api.createRecord('39d1db87', component.options)
    } else {
      api.reload('39d1db87', component.options)
    }
    module.hot.accept("./DashboardClientPostLogoutRedirectUri.vue?vue&type=template&id=39d1db87&", function () {
      api.rerender('39d1db87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientDashboard/DashboardClientPostLogoutRedirectUri.vue"
export default component.exports